export enum EXTEND_EVENTS  {
  RTC_STATE_CHANGE = 'core.rtcstatechange',
  RTC_NETWORK = 'core.rtcnetwork',
  RTC_FIRST_FRAME = 'core.rtcfirstframe'
}

export enum RTC_FIRST_FRAME_STATE {
  LOAD_START = 'start_load',
  OFFER_SDP_READY = 'offer_sdp_ready',
  ANSWER_SDP_RECV = 'answer_sdp_recv',
  ANSWER_SDP_READY = 'answer_sdp_ready',
  ICE_CONNECTED = 'ice_connected',
  DTLS_CONNECTED = 'dtls_connected',
  PEER_CONNECTED = 'peer_connected',
  FIRST_PACKET_RECV = 'first_packet_recv',
  FIRST_FRAME_RECV = 'first_frame_recv',
  FIRST_FRAME_DECODED = 'first_frame_decoded',
  VIDEO_PLAYING = 'video_playing',
  VIDEO_CANPLAY = 'video_canplay',
  VIDEO_LOADEDDATA = 'video_loadeddata'
}
